import * as React from 'react';
import { useState } from 'react';

import { use$ } from '@legendapp/state/react';
import { Breakpoints, CTA } from '@volkswagen-onehub/components-core';
import { ChevronDown, ChevronLeft, ChevronRight, ChevronUp } from '@volkswagen-onehub/icons-core';
import styled, { css, keyframes } from 'styled-components';

import translate from '../../utils/translate';

import { TrackingEventName, ZoomActionTypes } from '../../store/stores/tracking/types';

import {
	degreeImageStore,
	degreeImageStoreActions,
	interiorStore,
	interiorStoreActions,
	zoomStore,
	zoomStoreActions
} from '../../store';
import { trackingStore } from '../../store/stores/tracking-store';
import { testId } from '../../test-utils/constants';

const ROTATION_STEP_DEGREES = 10;
const PAN_STEP_DEGREES = 10;

const A11yIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M5.94308 7.87513L4.67346 11.514C4.64225 11.6052 4.5938 11.689 4.53095 11.7605C4.4681 11.832 4.39212 11.8898 4.30747 11.9304C4.18031 11.9923 4.03831 12.0136 3.89947 11.9916C3.76063 11.9696 3.63119 11.9054 3.52758 11.8071C3.42396 11.7087 3.35082 11.5807 3.31743 11.4392C3.28403 11.2977 3.29189 11.1491 3.34 11.0122L4.22519 8.4696C4.29544 8.27827 4.35094 8.08146 4.39117 7.88102C4.42694 7.67751 4.45251 7.47222 4.46777 7.26596C4.50181 6.89369 4.52593 6.49051 4.54437 6.10352C4.56281 5.71654 4.57558 5.34132 4.58551 5.03085C4.59828 4.64386 4.49756 4.61884 4.19824 4.54527L4.13582 4.53056L1.5824 4.03174C1.49056 4.01494 1.40282 3.97952 1.3242 3.92751C1.24558 3.87549 1.17761 3.80791 1.1242 3.72862C1.04484 3.60851 1.00164 3.46668 1.00005 3.32108C0.998454 3.17548 1.03855 3.03266 1.11526 2.91072C1.19196 2.78877 1.30183 2.69317 1.43095 2.63603C1.56006 2.57889 1.70262 2.56278 1.84058 2.58973L4.58409 3.12386C4.69332 3.13416 4.79971 3.14741 4.91178 3.16065C5.24939 3.20863 5.58957 3.23468 5.93032 3.23863C6.35448 3.23004 6.77786 3.19713 7.19852 3.14005C7.32619 3.12533 7.44677 3.10915 7.56735 3.09738L10.1562 2.59415C10.3399 2.55464 10.5312 2.5922 10.6882 2.69862C10.766 2.75324 10.8326 2.82336 10.8841 2.9049C10.9356 2.98644 10.9709 3.07778 10.9881 3.17362C11.0052 3.26945 11.0039 3.36786 10.984 3.46314C10.9642 3.55842 10.9263 3.64866 10.8726 3.72862C10.8199 3.80841 10.7526 3.87664 10.6745 3.92941C10.5963 3.98218 10.5089 4.01845 10.4173 4.03615L7.94327 4.51879C7.86099 4.53791 7.78722 4.55116 7.72197 4.56146C7.46379 4.60707 7.33612 4.63062 7.35172 5.01172C7.36307 5.28982 7.3957 5.62236 7.43826 5.96962C7.48791 6.37721 7.55316 6.80981 7.62125 7.20563C7.66523 7.46607 7.70637 7.67502 7.76311 7.87513C7.81985 8.07525 7.87517 8.27978 7.96029 8.52551L8.82704 11.0122C8.87515 11.1491 8.88301 11.2977 8.84962 11.4392C8.81622 11.5807 8.74308 11.7087 8.63947 11.8071C8.53585 11.9054 8.40642 11.9696 8.26757 11.9916C8.12873 12.0136 7.98673 11.9923 7.85957 11.9304C7.77492 11.8898 7.69894 11.832 7.63609 11.7605C7.57324 11.689 7.52479 11.6052 7.49358 11.514L6.2197 7.88249L6.07785 7.61322L5.93599 7.87513H5.94308ZM5.99841 6.92648e-07C6.28822 -0.000254866 6.56914 0.103734 6.79332 0.294248C7.01749 0.484762 7.17105 0.750012 7.22781 1.0448C7.28457 1.33959 7.24103 1.64567 7.10461 1.91089C6.96819 2.17611 6.74733 2.38406 6.47966 2.4993C6.21199 2.61454 5.91408 2.62994 5.63669 2.54287C5.35931 2.45581 5.11961 2.27167 4.95844 2.02184C4.79727 1.772 4.7246 1.47193 4.75283 1.17275C4.78105 0.873566 4.90842 0.593794 5.11322 0.381103C5.22924 0.260159 5.36718 0.16422 5.5191 0.0988132C5.67102 0.0334064 5.83392 -0.000175874 5.99841 6.92648e-07Z"
			fill="#1B2236"
		/>
	</svg>
);

const ZoomInIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M5.25 0C8.46176 -0.000201288 10.5 2.35051 10.5 5.25C10.5 6.47643 10.1336 7.60338 9.46973 8.49707L12 11.0303L11.5303 11.501L11.0596 11.9707L8.53809 9.44629C7.67682 10.1076 6.56151 10.4999 5.25 10.5C2.03835 10.5002 0.000149098 8.15033 0 5.25098C0 2.35148 2.03824 0.000201741 5.25 0ZM5.25 1.33008C2.82481 1.33023 1.33008 3.03288 1.33008 5.25098C1.33026 7.46888 2.82496 9.17007 5.25 9.16992C7.67519 9.16977 9.16992 7.46809 9.16992 5.25C9.16988 3.03195 7.67516 1.32993 5.25 1.33008ZM5.89941 4.58008H7.66504V5.91016H5.89941V7.67578H4.56934V5.91016H2.83496V4.58008H4.56934V2.8457H5.89941V4.58008Z"
			fill="#1B2236"
		/>
	</svg>
);

const ZoomOutIcon = () => (
	<svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
		<path
			d="M5.25 6.10352e-05C8.46176 -0.000140253 10.5 2.35057 10.5 5.25006C10.5 6.47649 10.1336 7.60344 9.46973 8.49713L12 11.0303L11.5303 11.501L11.0596 11.9708L8.53809 9.44635C7.67684 10.1075 6.56143 10.5 5.25 10.5001C2.03849 10.5001 0.000149094 8.15031 0 5.25104C0 2.35162 2.03838 0.000381913 5.25 6.10352e-05ZM5.25 1.33014C2.82495 1.33041 1.33008 3.03302 1.33008 5.25104C1.33026 7.46886 2.8251 9.17002 5.25 9.16998C7.67519 9.16983 9.16992 7.46816 9.16992 5.25006C9.16988 3.03201 7.67516 1.32999 5.25 1.33014ZM7.66504 5.92584H2.83496V4.59576H7.66504V5.92584Z"
			fill="#1B2236"
		/>
	</svg>
);

export const A11yControls = () => {
	const [isExpanded, setIsExpanded] = useState(false);
	const isInteriorMode = use$(interiorStore.isInteriorLoaded);
	const isZoomed = use$(zoomStore.isZoomed);
	const track = trackingStore.track;

	const handleZoom = (direction: 1 | -1) => {
		track(TrackingEventName.VISUALIZER_VEHICLE_ZOOM, {
			contentId: ZoomActionTypes.UI_INTERACTION
		});

		if (direction === 1) {
			const [, maxZoomLevel] = zoomStore.zoomRanges.get();
			zoomStoreActions.setZoomLimit(1);
			zoomStoreActions.setZoomLevel(maxZoomLevel);
			return;
		}

		zoomStoreActions.resetZoom();
	};

	const handleRotate = (steps: 1 | -1) => {
		if (isInteriorMode) {
			interiorStoreActions.requestInteriorPan(-steps * PAN_STEP_DEGREES, 0);
			return;
		}

		const currentDegree = degreeImageStore.currentDegree.get() || 0;
		let newDegree = (currentDegree + steps * ROTATION_STEP_DEGREES) % 360;
		if (newDegree < 0) newDegree += 360;
		degreeImageStoreActions.setCurrentDegree(newDegree);
	};

	const handleTilt = (direction: 1 | -1) => {
		interiorStoreActions.requestInteriorPan(0, direction * PAN_STEP_DEGREES);
	};

	const groupId = testId('A11y_Controls_Group');
	const inertWhenHidden = isExpanded ? {} : ({ inert: '' } as Record<string, string>);

	return (
		<>
			<ToggleButton
				tag="button"
				emphasis="tertiary"
				data-testid={testId('A11y_Controls_Toggle')}
				aria-label={translate('global.ariaLabel.accessibilityControls')}
				title={translate('global.ariaLabel.accessibilityControls')}
				aria-expanded={isExpanded}
				aria-controls={groupId}
				$isActive={isExpanded}
				onClick={() => setIsExpanded(expanded => !expanded)}
				icon={<A11yIcon />}
			/>
			<ButtonsGroup
				id={groupId}
				role="group"
				aria-label={translate('global.ariaLabel.accessibilityControls')}
				$isVisible={isExpanded}
				{...inertWhenHidden}
			>
				<ControlButton
					tag="button"
					emphasis="tertiary"
					data-testid={testId('A11y_Zoom_In')}
					aria-label={translate('global.ariaLabel.zoomIn')}
					title={translate('global.ariaLabel.zoomIn')}
					disabled={isZoomed}
					onClick={() => handleZoom(1)}
					icon={<ZoomInIcon />}
				/>
				<ControlButton
					tag="button"
					emphasis="tertiary"
					data-testid={testId('A11y_Zoom_Out')}
					aria-label={translate('global.ariaLabel.zoomOut')}
					title={translate('global.ariaLabel.zoomOut')}
					disabled={!isZoomed}
					onClick={() => handleZoom(-1)}
					icon={<ZoomOutIcon />}
				/>
				<ControlButton
					tag="button"
					emphasis="tertiary"
					data-testid={testId('A11y_Rotate_Left')}
					aria-label={translate('global.ariaLabel.rotateLeft')}
					title={translate('global.ariaLabel.rotateLeft')}
					$groupStart
					onClick={() => handleRotate(1)}
					icon={<ChevronLeft aria-hidden variant="small" />}
				/>
				<ControlButton
					tag="button"
					emphasis="tertiary"
					data-testid={testId('A11y_Rotate_Right')}
					aria-label={translate('global.ariaLabel.rotateRight')}
					title={translate('global.ariaLabel.rotateRight')}
					onClick={() => handleRotate(-1)}
					icon={<ChevronRight aria-hidden variant="small" />}
				/>
				{isInteriorMode && (
					<>
						<ControlButton
							tag="button"
							emphasis="tertiary"
							data-testid={testId('A11y_Tilt_Up')}
							aria-label={translate('global.ariaLabel.tiltUp')}
							title={translate('global.ariaLabel.tiltUp')}
							onClick={() => handleTilt(1)}
							icon={<ChevronUp aria-hidden variant="small" />}
						/>
						<ControlButton
							tag="button"
							emphasis="tertiary"
							data-testid={testId('A11y_Tilt_Down')}
							aria-label={translate('global.ariaLabel.tiltDown')}
							title={translate('global.ariaLabel.tiltDown')}
							onClick={() => handleTilt(-1)}
							icon={<ChevronDown aria-hidden variant="small" />}
						/>
					</>
				)}
			</ButtonsGroup>
		</>
	);
};

const dissolveFade = keyframes`
	from {
		opacity: 0;
	}
	to {
		opacity: 1;
	}
`;

const RoundCtaMixin = css`
	&& {
		width: 32px;
		height: 32px;
		min-width: 32px;
		min-height: 32px;
		padding: 0;
		margin: 0;
		border: none;
		border-radius: 50%;
		overflow: hidden;
		-webkit-tap-highlight-color: transparent;
		transition: background 0.2s;
	}

	&&,
	&&:hover,
	&&:active,
	&&:focus {
		background: #ffffff;
		color: #1b2236;
	}

	&& svg,
	&& svg [stroke] {
		color: #1b2236;
	}

	&&:focus-visible {
		outline: 2px solid #c86c03;
		outline-offset: 1px;
	}
`;

const ToggleButton = styled(CTA)<{ $isActive: boolean }>`
	${RoundCtaMixin}

	position: absolute;
	z-index: 5;
	top: 12px;
	inset-inline-end: 12px;

	&& svg {
		display: block;
		width: 12px;
		height: 12px;
	}

	@media (min-width: ${Breakpoints.b960}px) {
		top: 16px;
		inset-inline-end: 16px;
		animation: ${dissolveFade} 0.35s ease 0.6s both;
	}

	@media (hover: hover) {
		&&:hover {
			background: #ccbdab;
		}
	}

	${({ $isActive }) => $isActive && '&&, &&:hover, &&:active, &&:focus { background: #ccbdab; }'}
`;

const ButtonsGroup = styled.div<{ $isVisible: boolean }>`
	position: absolute;
	z-index: 5;
	top: 12px;
	inset-inline-end: 56px;

	display: flex;
	align-items: center;
	gap: 8px;

	pointer-events: none;
	opacity: 0;
	transform: scale(0.8);
	transform-origin: right center;
	transition:
		opacity 0.15s ease-in,
		transform 0.15s ease-in;

	@media (min-width: ${Breakpoints.b960}px) {
		top: 16px;
	}

	${({ $isVisible }) =>
		$isVisible &&
		css`
			pointer-events: auto;
			opacity: 1;
			transform: scale(1);
			transition:
				opacity 0.5s cubic-bezier(0.34, 1.56, 0.64, 1),
				transform 0.5s cubic-bezier(0.34, 1.56, 0.64, 1);

			& > button {
				opacity: 1;
				transform: scale(1);
				transition:
					opacity 0.45s cubic-bezier(0.34, 1.56, 0.64, 1),
					transform 0.45s cubic-bezier(0.34, 1.56, 0.64, 1);
			}

			& > button:nth-child(1) {
				transition-delay: 120ms;
			}
			& > button:nth-child(2) {
				transition-delay: 80ms;
			}
			& > button:nth-child(3) {
				transition-delay: 40ms;
			}
			& > button:nth-child(4) {
				transition-delay: 0ms;
			}
			& > button:nth-child(5) {
				transition-delay: 40ms;
			}
			& > button:nth-child(6) {
				transition-delay: 0ms;
			}

			& > button:disabled {
				opacity: 0.3;
			}
		`}
`;

const ControlButton = styled(CTA)<{ $groupStart?: boolean }>`
	${RoundCtaMixin}

	flex-shrink: 0;
	opacity: 0;
	transform: scale(0.5);
	transition:
		opacity 0.1s ease-in,
		transform 0.1s ease-in;

	${({ $groupStart }) => $groupStart && '&& { margin-inline-start: 20px; }'}

	&& svg {
		display: block;
		width: 12px;
		height: 12px;
	}

	@media (hover: hover) {
		&&:hover:not(:disabled) {
			background: #ccbdab;
		}
	}

	&&:disabled {
		cursor: default;
		pointer-events: none;
	}
`;
